/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamGrid200,
  GetApiV1ExamGrid400,
  GetApiV1ExamGrid401,
  GetApiV1ExamGrid500,
  GetApiV1ExamGridQueryParams,
  GetApiV1ExamGridQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamGrid.ts";
import { examGridListItemViewModelSchema } from "../examGridListItemViewModelSchema.ts";

export const getApiV1ExamGridQueryParamsSchema = z
  .object({
    DisciplineId: z.optional(z.coerce.number().int()),
    CompanyId: z.optional(z.coerce.number().int()),
    Title: z.optional(z.string()),
    Active: z.optional(z.boolean()),
    ExamType: z.optional(z.coerce.number().int()),
    Status: z.optional(z.coerce.number().int()),
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
    SortField: z.optional(z.string()),
    SortDirection: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamGridQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamGrid200Schema = z.array(
  z.lazy(() => examGridListItemViewModelSchema),
) as unknown as ToZod<GetApiV1ExamGrid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamGrid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamGrid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamGrid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamGrid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamGrid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamGrid500>;

export const getApiV1ExamGridQueryResponseSchema = z.lazy(
  () => getApiV1ExamGrid200Schema,
) as unknown as ToZod<GetApiV1ExamGridQueryResponse>;
